import { type ReactNode, useEffect } from "react";
import { getToken, login } from "../auth/auth";

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const token = getToken();

  useEffect(() => {
    if (!token) {
      login();
    }
  }, [token]);

  if (!token) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
